<template>
  <div v-if="!hide_muna && hint != ''">
    <v-slide-x-transition>
      <v-row fluid class="fill-height trh-container">
        <v-col class="trh-options-container" style="z-index: 3">
          <div class="absolute">
            <v-btn icon class="mb-n3" @click="closeHint"><v-icon>mdi-close</v-icon></v-btn>
          </div>
          <h4 class="trh-header primary--text text-center">Text Replacement Hint</h4>
          <small class="error--text">
            <i>Please press tab if the entered key matches one of the key items in the list or click the desired item.</i>
          </small>
          <v-data-table
            :items="options"
            hide-default-footer
            class="sticky mt-5"
            :disable-sort="true"
            :headers="headers"
          >
            <template v-slot:item="{ item }">
              <tr @click="selectReplacement(item.replacement)" class="pointer">
                <!-- Row Name -->
                <td>
                  <v-list-item dense class="px-0">
                    <v-list-item-content>
                      <v-list-item-title>
                        <span class="trh-option-label" v-html="htmlDisplay(item.key)"></span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </td>
                <td>
                  <v-list-item dense class="px-0">
                    <v-list-item-content>
                      <v-list-item-title class="text-wrap">
                        {{ item.replacement }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-slide-x-transition>
  </div>
</template>

<script>
import textreplacementmixin from '../../../mixins/textreplacementmixin';
export default {
  name: "TextReplacementHint",
  mixins: [textreplacementmixin],
  data () {
    return {
      options: [],
      last_text: '',
      headers: [
        { text: "Key", value: "key", width: "50px" },
        { text: "Text Value", value: "text", class: "grey--text text--darken-2" },
      ],
      hide_muna: false
    }
  },
  computed: {
    hint: {
      get() { return this.$store.getters["textreplacement/hint"]; },
      set(val) { return this.$store.commit("textreplacement/setHint", val); },
    },
    full_text_replacement: {
      get () { return this.$store.getters["textreplacement/full_text_replacement"]; },
      set () { return this.$store.commit('textreplacement/setFullTextReplacements'); }
    },
    matched_replacement: {
      get () { return this.$store.getters["textreplacement/matched_replacement"]; },
      set (val) { return this.$store.commit("textreplacement/setMatchedReplacement", val); },
    }
  },
  watch: {
    hint () {
      if (this.hint != '') {
        let last_line = this.hint.split('\n').pop();
        this.last_text = last_line.split(' ').pop();
        console.log('last text: ', this.last_text);
        this.matched_replacement = '';

        if (this.last_text != '' && this.last_text != undefined && this.last_text != null) {

          this.options = [];
          for (let ii in this.full_text_replacement) {

            if (this.full_text_replacement[ii].key.toLowerCase().indexOf(this.last_text.toLowerCase()) > -1) {
              this.options.push({
                key: this.full_text_replacement[ii].key,
                replacement: this.full_text_replacement[ii].replacement,
              });
            }

            if (this.full_text_replacement[ii].key.toLowerCase() == this.last_text) {
              this.matched_replacement = this.full_text_replacement[ii].replacement;
            }
          }
          
          if (this.options.length == 1) {
            let matched = this.options[0];
            this.matched_replacement = matched.replacement;
          } else if (this.options.length == 0) {
            this.hint = '';
            this.matched_replacement = '';  
          } 
        } else {
          this.hint = '';
          this.matched_replacement = '';
        } 
      } 
    }
  },
  mounted () {
    // this.$store.dispatch('textreplacement/fetchFullTextReplacements');
  },
  methods: {
    htmlDisplay (key) {
      let lowered = this.last_text.toLowerCase();
      let pos = key.toLowerCase().indexOf(lowered);
      
      let part = key.substr(pos, this.last_text.length);
      return key.replace(part, `<strong class="primary--text">${part}</strong>`);
    },
    selectReplacement (replacement) {
      this.matched_replacement = replacement;
      this.triggerSelection(this.hint);
    },
    closeHint () {
      this.hint = '';
      this.matched_replacement = '';
    }
  },
};
</script>

<style scoped>
.trh-container {
  position: absolute;
  z-index: 3007;
  background: rgba(0, 0, 0, 0.2);
  width: 25%;
  top: 0;
  right: 0;
  overflow-y: scroll;
  height: 100lvh;
  max-width: 400px;
  border-radius: 5px;
  border-left: 1px solid #b3b3b3;
}

.trh-options-container {
  background: #fff;
  border-top: 1px solid #b3b3b3;
  position: relative;
}

.trh-header {
  margin: 15px 15px 0 15px;
  font-size: 18px;
}

.trh-option-label {
    font-size: 14px;
}

.pointer {
  cursor: pointer;
}
</style>